<template>
    <div class="hello">
        <v-row class="mb-8">
            <v-col cols="12">
                <div class="text-h3 font-weight-bold primary--text text-center mb-2">
                    {{ msg }}
                </div>
                <div class="text-h6 text-center grey--text text--darken-1">
                    Sistema de seguiment en temps real
                </div>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" md="4" v-for="(item, index) in menuItems" :key="index">
                <v-card 
                    class="menu-card" 
                    elevation="6" 
                    hover
                    :to="item.route"
                >
                    <v-card-text class="text-center pa-8">
                        <v-avatar :color="item.color" size="120" class="mb-4">
                            <v-icon size="60" dark>{{ item.icon }}</v-icon>
                        </v-avatar>
                        <div class="text-h5 font-weight-bold mb-2">
                            {{ item.title }}
                        </div>
                        <div class="text-body-1 grey--text">
                            {{ item.description }}
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="mt-8">
            <v-col cols="12" md="6">
                <v-card elevation="4" class="feature-card">
                    <v-card-title class="primary white--text">
                        <v-icon left dark>mdi-speedometer</v-icon>
                        Característiques
                    </v-card-title>
                    <v-card-text class="pa-6">
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="success">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>Seguiment en temps real</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="success">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>Control per categories</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="success">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>Registre de temps per volta</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon color="success">mdi-check-circle</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>Sistema de sorteig de premis</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="6">
                <v-card elevation="4" class="info-card">
                    <v-card-title class="accent white--text">
                        <v-icon left dark>mdi-information</v-icon>
                        Com funciona
                    </v-card-title>
                    <v-card-text class="pa-6">
                        <v-timeline dense>
                            <v-timeline-item color="primary" small>
                                <div class="font-weight-bold">Pas 1</div>
                                Selecciona la categoria de la carrera
                            </v-timeline-item>
                            <v-timeline-item color="primary" small>
                                <div class="font-weight-bold">Pas 2</div>
                                Inicia el cronòmetre quan comenci la cursa
                            </v-timeline-item>
                            <v-timeline-item color="primary" small>
                                <div class="font-weight-bold">Pas 3</div>
                                Registra les voltes dels participants
                            </v-timeline-item>
                            <v-timeline-item color="primary" small>
                                <div class="font-weight-bold">Pas 4</div>
                                Consulta els resultats en temps real
                            </v-timeline-item>
                        </v-timeline>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "Home",
    props: {
        msg: String,
    },
    data() {
        return {
            menuItems: [
                {
                    title: 'Categories',
                    description: 'Gestiona les categories i carreres',
                    icon: 'mdi-format-list-bulleted',
                    color: 'primary',
                    route: '/categories'
                },
                {
                    title: 'Sorteig',
                    description: 'Realitza sorteigs de premis',
                    icon: 'mdi-gift',
                    color: 'secondary',
                    route: '/lottery'
                },
            ]
        };
    },
};
</script>

<style scoped lang="scss">
.hello {
    padding: 20px;
}

.menu-card {
    transition: all 0.3s ease;
    cursor: pointer;
    height: 100%;
    border-radius: 16px !important;

    &:hover {
        transform: translateY(-8px);
    }
}

.feature-card,
.info-card {
    height: 100%;
    border-radius: 12px !important;
}
</style>
